import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getCountEvents } from '@zero5/garage-api';

import { mapCountPendingEventsResponse } from '@/api/mappings/event';

import useDateModule from '@/utils/date/useDateModule';

type Response = ReturnType<typeof mapCountPendingEventsResponse>;

export const queryKey: QueryKey = 'count-events';

const useCountPendingScheduledEventQuery = (
  options?: UseQueryOptions<Response, unknown, Response, typeof queryKey>,
) => {

  const { getTimestampOfCurrentMonthEnd, getTimestampOfCurrentMonthStart } = useDateModule();

  return useQuery(
    queryKey,
    async () => {
      const now = new Date();
      const response = await getCountEvents({
        fromDate: getTimestampOfCurrentMonthStart(),
        toDate: getTimestampOfCurrentMonthEnd(),
        currentDate: now.getTime(),
      });
      return mapCountPendingEventsResponse(response);
    },
    {
      refetchOnWindowFocus: false,
      ...options,
    },
  );
};

export default useCountPendingScheduledEventQuery;
